export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CONTENT_LOADED = 'CONTENT_LOADED'
export const LOAD_CONTENT_STARTED = 'LOAD_CONTENT_STARTED'
export const IMAGE_LOAD = 'IMAGE_LOAD'



// WEBPACK FOOTER //
// ./src/redux/actions/action-types.js